export default __webpack_public_path__ + "static/media/a023-startup5.336282e4.png";